<template>
  <!-- Page Content -->
  <div id='page-wrapper'>
    <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
    <div class='container-fluid'>
      <div class='row'>
        <div class='col-lg-12'>
          <h1 class='page-header'>تقرير موظفى التيلر</h1>
        </div>
        <!-- /.col-lg-12 -->
      </div>
      <!-- /.row -->
      <div class='row'>
        <div class='col-lg-12'>
          <div class='panel panel-default'>
            <div class='panel-heading'>
              هنا يتم عرض تقرير موظفى التيلر
            </div>
            <div class='alert alert-danger alert-dismissable' v-if='validationErrors'>
              <ul v-if='validationErrors'>
                  <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
              </ul>
            </div>
            <div class='form-group col-lg-3 col-md-3 col-sm-4'>
              <label >الفرع:</label>
              <select @change='getEmp()' class="form-control" v-model="branche_id">
                <option v-for="item in branches" :key="item.id" v-bind:value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class='form-group col-lg-3 col-md-3 col-sm-4'>
              <label >الموظف:</label>
              <select class="form-control" style="padding: 0px" v-model="user_id">
                <option v-for="(item) in emps" v-bind:key="item.id" v-bind:value="item.id">
                  {{ item.name }}
                </option>
              </select>
            </div>
            <div class='form-group col-lg-3 col-md-3 col-sm-4'>
              <tbDate  :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
            </div>
            <div class='form-group col-lg-3 col-md-3 col-sm-4'>
              <tbDate  :mytitle='toTitle' v-model= 'to_date' ></tbDate>
            </div>
            <div class='form-group col-lg-3 col-sm-4'>
              <button @click='GetData' type='button' class='btn btn-primary btn-block'>عرض</button>
            </div>
            <!-- /.panel-heading -->
            <div class='panel-body'>
              <table width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                <thead>
                  <tr>
                    <th style='text-align: center'>م</th>
                    <th style='text-align: center'>ك.العميل</th>
                    <th style='text-align: center'>اسم العميل</th>
                    <th style='text-align: center'>التاريخ</th>
                    <th style='text-align: center'>الحركة</th>
                    <th style='text-align: center'>المبلغ</th>
                  </tr>
                </thead>
                <tbody>
                  <tr class='odd gradeX' v-for='(record,index) in records' :key='record.id'>
                    <td align='center'>{{index+1}}</td>
                    <td align='right'>{{record.rec_id}}{{record.rec_id_letter}}</td>
                    <td align='center'>{{record.name}}</td>
                    <td align='center'>{{record.created_at}}</td>
                    <td align='center'>{{record.action}}</td>
                    <td align='center'>{{record.price}}</td>
                  </tr>
                </tbody>
              </table>
              <!-- /.table-responsive -->
            </div>
            <!-- /.panel-body -->
          </div>
          <!-- /.panel -->
        </div>
        <!-- /.col-lg-12 -->
      </div>
    </div>
    <!-- /.container-fluid -->
  </div>
</template>
<script>
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
export default {
  name: 'TellerUsersReport',
  components: {
    tbDate
  },
  data () {
    return {
      fromTitle: 'من',
      toTitle: 'إلى',
      from_date: '',
      to_date: '',
      records: {},
      emps: {},
      branches: [],
      branche_id: '',
      user_id: '',
      isLoadingData: false,
      validationErrors: ''
    }
  },
  created () {
    this.branche_id = localStorage.getItem('BrancheID')
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.getEmp()
  },
  methods: {
    getEmp () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getBranchEmp', {
        token: localStorage.getItem('token'),
        branch_id: this.branche_id
      })
        .then(({ data }) => {
          this.emps = data
          this.isLoadingData = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.isLoadingData = false
        })
    },
    GetData () {
      this.isLoadingData = true
      this.validationErrors = ''
      axios.post(this.$apiURL + 'getTeller_users', {
        token: localStorage.getItem('token'),
        user_id: this.user_id,
        from_date: this.from_date,
        to_date: this.to_date
      })
        .then(({data}) => {
          this.records = data
          this.isLoadingData = false
        })
        .catch(err => {
          this.records = {}
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.isLoadingData = false
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/employees/ReportTellerUsers.vue